// extracted by mini-css-extract-plugin
export default {"wrapper":"RemainingArticles-module__wrapper--MQmEX","text":"RemainingArticles-module__text--SmlVi"};